import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { confidenceCheckerAdminKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

async function addTeam(teamId: number): Promise<void> {
  await apiClient.url(`/confidence-checker-admin/teams/${teamId}`).post().res();
}

export function useAddConfidenceCheckerTeam(): UseMutationResult<
  void,
  Error,
  number
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addTeam,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: confidenceCheckerAdminKeys.all,
      });
    },
  });
}
